var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.625 3.75h-4.5l-1.5-1.5h-3c-.633 0-1.125.516-1.125 1.125v6A1.11 1.11 0 0 0 3.625 10.5h9c.61 0 1.125-.492 1.125-1.125v-4.5a1.14 1.14 0 0 0-1.125-1.125zm-1.688 9H3.064A2.791 2.791 0 0 1 .25 9.937V4.314c0-.305.234-.563.563-.563a.57.57 0 0 1 .562.563v5.625c0 .937.75 1.687 1.688 1.687h7.874a.57.57 0 0 1 .563.563.555.555 0 0 1-.563.562z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGroup);
export default __webpack_public_path__ + "static/media/icon-group.ff87555433627700ef7728e1f8062cf8.svg";
export { ForwardRef as ReactComponent };